import { Link } from 'react-router-dom';
import ArticleCard from '@/components/base/ArticleCard';
import { articles } from '@/mocks/articles';

export default function LatestNews() {
  const latestArticles = articles.filter((a) => a.featured);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
              最新动态
            </h2>
            <p className="text-sm text-foreground-500">第一时间了解小野坂唯香的最新资讯</p>
          </div>
          <Link
            to="/category/news"
            className="hidden sm:flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {latestArticles.slice(0, 1).map((article) => (
            <ArticleCard key={article.id} article={article} featured />
          ))}
          <div className="flex flex-col gap-4">
            {latestArticles.slice(1, 3).map((article) => (
              <ArticleCard key={article.id} article={article} />
            ))}
          </div>
        </div>

        <div className="mt-6 text-center sm:hidden">
          <Link
            to="/category/news"
            className="inline-flex items-center gap-1 text-sm font-medium text-primary-500 whitespace-nowrap"
          >
            查看全部动态 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}